import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JarmixCalculatorService {
  constructor(private http: HttpClient) { }

  //jarmix calculator export to pdf section
  ExportPdf(jarmixCalculationData: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.EXPORT_PDF_JARMIX);
    return this.http.post(appURL, jarmixCalculationData, {
      responseType: 'blob'
    });
  }
}
